import { render, staticRenderFns } from "./scroll-word.vue?vue&type=template&id=254a762e"
import script from "./scroll-word.vue?vue&type=script&lang=js"
export * from "./scroll-word.vue?vue&type=script&lang=js"
import style0 from "./scroll-word.vue?vue&type=style&index=0&id=254a762e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports